import { createContext, useContext } from "react"
import { getCurrencySymbol, isDefaultCurrency } from "helpers/formatters/numbers"

const TRAILING_DOLLAR_SUFFIX = /\s*\(\$\)$/

export function buildScaledCurrencyLabel(label: string, currencyScale: string | null, currency?: string | null): string {
  if (!currencyScale) return label

  const scaleSuffix = isDefaultCurrency(currency)
    ? `($${currencyScale})`
    : `(${getCurrencySymbol(currency)} ${currencyScale})`
  return TRAILING_DOLLAR_SUFFIX.test(label)
    ? label.replace(TRAILING_DOLLAR_SUFFIX, ` ${scaleSuffix}`)
    : `${label} ${scaleSuffix}`
}

interface CurrencyScaleContextValue {
  currencyScale: string | null
  currency?: string | null
}

const CurrencyScaleContext = createContext<CurrencyScaleContextValue>({ currencyScale: null })

export const CurrencyScaleProvider = CurrencyScaleContext.Provider

interface CurrencyScaledLabelProps {
  label: string
}

export function CurrencyScaledLabel({ label }: CurrencyScaledLabelProps) {
  const { currencyScale, currency } = useContext(CurrencyScaleContext)
  return buildScaledCurrencyLabel(label, currencyScale, currency)
}
